import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  prev(event) {
    event.preventDefault()
    this.navigate(-1)
  }

  next(event) {
    event.preventDefault()
    this.navigate(1)
  }

  navigate(direction) {
    const input = this.inputTarget

    if (input.tagName === "SELECT") {
      // For selects: move through options (skip the blank placeholder)
      const options = [...input.options].filter(o => o.value !== "")
      const currentIndex = options.findIndex(o => o.selected)
      const newIndex = currentIndex + direction

      if (newIndex >= 0 && newIndex < options.length) {
        input.value = options[newIndex].value
        input.dispatchEvent(new Event("change", { bubbles: true }))
      }
    } else if (input.type === "date") {
      // For date inputs: shift by one day
      const current = new Date(input.value)
      current.setDate(current.getDate() + direction)
      input.value = current.toISOString().split("T")[0]
      input.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
